import React, { useEffect, useState } from 'react';
import TeamInfo from '../TeamInfo/TeamInfo';
import TeamSlider from '../TeamSlider/TeamSlider';
import client from '../../../utils/prismicHelpers';

import * as queries from "../../../utils/prismicQueries";

import './teamSection.css'
const TeamSection = () => {
    const [teamInfo,setTeamInfo] = useState(null);
    useEffect(() => {
        client
            .query({
                query: queries.teamInfo,
            })
            .then((response) => {
                const socialLinks = response.data.allTeams.edges[0].node;
                setTeamInfo(socialLinks);

            })
            .catch((error) => {
                console.error(error);
            });
    });

    return (
        <section id="team" className="team-container pattern">
            <div id='team-stepper' className="container stepper">
                <div className="row  ">
                    <div className="col-md-6">
                        <TeamInfo teamInfo={teamInfo}></TeamInfo>
                    </div>
                    <div className="col-md-6 ">
                        <TeamSlider></TeamSlider>
                    </div>

                </div>
            </div>
        </section>

    );


};

export default TeamSection;